'use client'

import { Loading as LoadingIndicator } from '@/components/ui/loading'

export default function Loading() {
  return (
    <div className="flex min-h-[80dvh] w-full items-center justify-center px-10 py-28">
      <LoadingIndicator />
    </div>
  )
}
